/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_CHANGEPASSWORDWEB, CHANGEPASSWORDWEB_RECEIVED } = constants.ChangePasswordWeb;

export default {
  REQUEST_CHANGEPASSWORDWEB,
  CHANGEPASSWORDWEB_RECEIVED,

  ChangePasswordWebData: payload => ({
    type: REQUEST_CHANGEPASSWORDWEB,
    payload
  }),
  ChangePasswordWebReceived: () => ({
    type: CHANGEPASSWORDWEB_RECEIVED
  })
};
